<script setup lang="ts">
// ToastsHost — единый хост тостов (монтируется один раз в App.vue).
// Правый нижний угол, стек, анимация въезда/ухода, иконка по тону, ручное закрытие.
import { useToasts } from './useToasts';
import { CheckCircle2, XCircle, Info, X } from 'lucide-vue-next';

const toasts = useToasts();
const icon = { success: CheckCircle2, error: XCircle, info: Info };
</script>

<template>
  <Teleport to="body">
    <div class="ui-toasts">
      <TransitionGroup name="ui-toast">
        <div
          v-for="t in toasts.items"
          :key="t.id"
          class="ui-toast"
          :class="'is-' + t.kind"
          role="status"
        >
          <component :is="icon[t.kind]" :size="18" class="ui-toast-icon" />
          <p class="ui-toast-text">{{ t.text }}</p>
          <button class="ui-toast-close" aria-label="Закрыть" @click="toasts.dismiss(t.id)"><X :size="14" /></button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
